export const constant =
  <T>(x: T) =>
  () =>
    x

export const truthy = constant(true)

export const falsy = constant(false)
